import { Season } from 'src/app/core/domain/season.enum';
import { MapPosition } from 'src/app/maps/domain/masterdata/map-position.model';
import { Webcam } from 'src/app/maps/domain/masterdata/webcam.model';

export class WebcamAdapter {
  static adapt(item: any): Webcam {
    if (!item) {
      return Webcam.empty;
    }

    const defaultIconSize = item.defaultIconSize ? item.defaultIconSize : Webcam.defaultIconSize;

    let positions: MapPosition[] = [];
    if (item.iconPosition && item.iconPosition !== '') {
      let iconPositions: MapPosition[] | MapPosition = JSON.parse(item.iconPosition);
      if (!Array.isArray(iconPositions)) {
        iconPositions = [iconPositions];
      }
      positions = iconPositions;
    }

    return new Webcam({
      guid: item.guid,
      name: item.title,
      url: item.url,
      type: item.displayType,
      season: Season.SummerAndWinter,
      iconPositions: positions,
      iconWidth: defaultIconSize[0],
      iconHeight: defaultIconSize[1],
      aspectRatio: item.aspectRatio,
    });
  }

  static adaptForApi(webcam: Webcam): any {
    return {
      guid: webcam.guid,
      assetCategory: webcam.category,
      title: webcam.name,
      url: webcam.url,
      displayType: webcam.type,
      iconPosition: JSON.stringify(webcam.iconPositions),
      aspectRatio: webcam.aspectRatio,
    };
  }
}
